module.exports = __webpack_public_path__ + "img/05.1dbd8528.png";